/**
 * Cornerstone 2.x llama siempre a getContext('2d', { desynchronized: true }).
 * En Android (sobre todo Samsung) eso produce tearing: rayas negras horizontales
 * al cine, pan, zoom o cambio rápido de corte. Safari iOS suele ignorarlo.
 *
 * Debe importarse lo antes posible (antes del primer paint de Cornerstone).
 * El atributo se fija en el primer getContext; forzamos desynchronized:false.
 */

export function patchCanvasNoDesync() {
  if (typeof HTMLCanvasElement === 'undefined') return
  const proto = HTMLCanvasElement.prototype
  if (proto._udvNoDesyncPatched) return

  const originalGetContext = proto.getContext
  if (typeof originalGetContext !== 'function') return

  proto.getContext = function udvGetContext(type, attrs) {
    if (type === '2d' && attrs && typeof attrs === 'object' && attrs.desynchronized) {
      attrs = Object.assign({}, attrs, { desynchronized: false })
    }
    return originalGetContext.call(this, type, attrs)
  }

  proto._udvNoDesyncPatched = true
}

/**
 * Fija el contexto 2d del canvas de Cornerstone ANTES de que él lo abra
 * con desynchronized:true (si el patch no corrió a tiempo).
 * @param {HTMLElement|null|undefined} element
 */
export function lockCornerstoneCanvasContext(element) {
  if (!element || typeof element.querySelector !== 'function') return
  try {
    const canvas =
      element.querySelector('canvas.cornerstone-canvas') ||
      element.querySelector('canvas')
    if (!canvas || typeof canvas.getContext !== 'function') return
    canvas.getContext('2d', { alpha: false, desynchronized: false })
  } catch (e) {
    /* ignore */
  }
}

patchCanvasNoDesync()
